import { render, staticRenderFns } from "./AddTransportationAlert.vue?vue&type=template&id=b5f829ee&scoped=true"
import script from "./AddTransportationAlert.vue?vue&type=script&lang=ts"
export * from "./AddTransportationAlert.vue?vue&type=script&lang=ts"
import style0 from "./AddTransportationAlert.vue?vue&type=style&index=0&id=b5f829ee&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b5f829ee",
  null
  
)

export default component.exports